module.exports = __webpack_public_path__ + "img/ky.93a85a5.svg";